import store from "../../store/store"
import { QueuesHubV2 } from "../hubs/queuesV2"

export const queuesV2Hub = new QueuesHubV2(store)
